import React from "react";
import { Card, CardBody, Button, CardFooter } from "reactstrap";

import FilterPanel, { FilterPanelProps } from "../../common/components/FilterPanel";

export interface AttendeeFiltersProps extends FilterPanelProps {
  sortDirection: "ascending" | "descending";
  onSortChanged: (direction: "ascending" | "descending") => any;
  onReset: () => any;
}

const AttendeeFilters: React.FC<AttendeeFiltersProps> = ({
  items, values, sortDirection, onChange, onSortChanged, onReset
}) => {

  const sorts: Record<string, string> = {
    "ascending": "Ascending",
    "descending": "Descending",
  };

  const anyValues = values.length !== 0;

  const onSortClick = (value: "ascending" | "descending") => {
    onSortChanged(value);
  };

  const onResetClick = () => {
    onReset();
  };

  return (
    <div className="no-line-spacing box-shadow">
      <Card>
        <CardBody>
          <div className="text-primary text-uppercase text-truncate text-center fs-9 fw-6 mx-2">
            Filters
          </div>
          <div className="mt-3">
            <FilterPanel items={items} values={values} onChange={onChange} />
          </div>
          <div className="mt-3 mx-1">
            {Object.keys(sorts).map(key => {
              const id = `sortby-${key}`;
              return (
                <label key={key} className="d-flex justify-content-start">
                  <input type="radio" name="sortby" id={id}
                    checked={anyValues && sortDirection === key}
                    onChange={() => { onSortClick(key as any); }}
                    disabled={!anyValues} />
                  <span className="ml-1">{sorts[key]}</span>
                </label>
              );
            })}
          </div>
        </CardBody>
        <CardFooter className="bg-panel-light">
          <div className="text-right">
            <Button
              size="sm"
              variant="secondary"
              onClick={onResetClick}
              disabled={!anyValues}>
              Clear all
            </Button>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AttendeeFilters;
